<template>
    <div class="d-flex flex-column align-items-center justify-content-center">
        <alert-success v-if="message" :class="'shadow-sm'" :form="sendPhoneForm" :message="message" :style="'width: -webkit-fill-available'"></alert-success>
		<div v-if="error" class="alert alert-warning alert-dismissible fade show shadow-sm" :style="'width: -webkit-fill-available'" role="alert">
			<div v-html="error"></div>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">x</span>
			</button>
		</div>

        <div class="wd-150 wd-sm-150 mg-b-30">
            <img :src="phone" class="img-fluid" alt="">
        </div>

        <template v-if="sent">
            <h4 class="tx-center">Please enter the one time password to verify your account</h4>
            <p class="tx-color-03 mg-b-30 tx-center">A code has been sent to {{ phoneNumber }}.</p>
            <form method="POST" @submit.prevent="verifyToken" class="wd-100p">
                <div class="wd-100p d-flex flex-column flex-sm-row">
                    <input v-model="verifyTokenForm.token" type="token" class="form-control wd-sm-250 flex-fill shadow-sm" :class="{ 'is-invalid': verifyTokenForm.errors.has('token') }" name="token" placeholder="Enter the OTP here" required>

                    <button-component :busy="verifyTokenForm.busy" :label="'Validate'" :label-loading="'Please wait...'" :button-class="'btn btn-default mg-sm-l-10 mg-t-10 mg-sm-t-0'"></button-component>
                </div>
                <has-error :form="verifyTokenForm" field="token" :class="{ 'd-block': verifyTokenForm.errors.has('token') }"></has-error>
            </form>
			<div class="tx-13 mg-t-20 tx-center">Still don't have a code? <a href="#" @click="sendPhone">Resend Code</a></div>

        </template>
        <template v-else>
            <h4 class="tx-20 tx-sm-24 tx-center">Reset your password</h4>
            <p class="tx-color-03 mg-b-30 tx-center">Please enter the phone number that you registered with. We will send you an otp for setting a new password.</p>

            <form method="POST" action="/password/phone" @submit.prevent="sendPhone">
                <div class="d-flex flex-column flex-sm-row">
                    <phone-number-component :flex-fill="true" :has-error="sendPhoneForm.errors.has('phone')" :country="sendPhoneForm.country_code" :phone-number="sendPhoneForm.phone" @update-phone-country="updatePhoneCountry" @update-phone="updatePhone" @update-phone-input="updatePhoneInput" :readonly="false"></phone-number-component>

                    <button-component :busy="sendPhoneForm.busy" :label="'Reset Password'" :label-loading="'Sending...'" :button-class="'btn btn-default mg-sm-l-10 mg-t-10 mg-sm-t-0'"></button-component>
                </div>
                <has-error :form="sendPhoneForm" field="phone" :class="{ 'd-block': sendPhoneForm.errors.has('phone') }"></has-error>
            </form>
        </template>
    </div>
</template>

<script>
	import phone from '../../../../img/phone.svg';

	export default {
		data() {
			return {
				phone,
				error: null,
				sent: false,
				message: '',
				response: null,
				phoneNumber: null,
				sendPhoneForm: new Form({
					phone: null,
					country_code: null,
				}),
				verifyTokenForm: new Form({
					token: null,
					signature: null,
					user: null,
				}),
			};
		},
		watch: {
			response(value) {
				if (value) {
					const {
						payload: { signature, user },
					} = value;

					this.verifyTokenForm.signature = signature;
					this.verifyTokenForm.user = user;
					this.sent = true;
				}
			},
		},
		methods: {
			updatePhone(value) {
				this.sendPhoneForm.phone = value;
			},
			updatePhoneInput(value) {
				this.phoneNumber = value;
			},
			updatePhoneCountry(value) {
				this.sendPhoneForm.country_code = value;
			},
			sendPhone() {
				this.error = null;
				this.sendPhoneForm
					.post('/api/auth/password/phone')
					.then(({ data: { data } }) => {
						const { status, ...response } = data;

						this.message = status;
						this.response = response;
						this.sent = true
					})
					.catch(() => {
						this.error = this.sendPhoneForm.errors.get('error');
					});
			},
			verifyToken() {
				this.message = null;

				this.verifyTokenForm
					.post('/api/otp/verify')
					.then(() => {
						window.location =  `/password/reset/${this.response.token}?phone=${this.phoneNumber}&country_code=${this.sendPhoneForm.country_code}`
					})
					.catch(({response : {data : {data}}}) => {
						this.error = data.message;
					});
			},
		},
	};
</script>

<style>
</style>
